import React, { useState } from 'react';
import './tripleToggleComponent.scss';

import { ReactComponent as InfoCircleIcon } from '../../assets/icons/infocircle.svg';
interface ITrippleToggleComponentProps {
    label?: string;
    getSelected?: (tab: number) => void;
}

const tripleToggleComponent = ({ label, getSelected }: ITrippleToggleComponentProps) => {
    const [selected, setSelected] = useState<number>(1);

    const setValue = (tab: number) => {
        setSelected(tab);
        if (getSelected != undefined) {
            getSelected(tab);
        }
    };

    return (
        <div className="tripleToggleComponent">
            {label != '' ? <div className="toggleLabel">{label}</div> : <></>}

            <div className="tripleToggleContainer">
                <div
                    onClick={() => {
                        setValue(1);
                    }}
                    className={`option left ${selected === 1 ? 'selected' : ''}`}
                >
                    고정
                </div>
                <div
                    onClick={() => {
                        setValue(2);
                    }}
                    className={`option middle ${selected === 2 ? 'selected' : ''}`}
                >
                    선택적
                </div>
                <div
                    onClick={() => {
                        setValue(3);
                    }}
                    className={`option right  ${selected === 3 ? 'selected' : ''}`}
                >
                    자율출퇴근
                </div>
            </div>

            <div className="description">
                <div className="icon">
                    <InfoCircleIcon />
                </div>
                {selected == 1 ? '출퇴근 시간이 고정되어 있습니다' : '출퇴근 시간을 자유롭게 선택할 수 있습니다'}
            </div>
        </div>
    );
};

export default tripleToggleComponent;
